/**
 * Maps a migration/registration `source_application` code to the product name
 * shown on return CTAs (e.g. "Continue to BidNet Direct").
 *
 * Codes look like `METS`, `METS:SSC`, or bare app names such as `ONTOPICAL`.
 */

const FALLBACK = "your application";

const BASE_NAMES: Record<string, string> = {
  METS: "BidNet Direct",
  ONTOPICAL: "SOVRA Edge",
  EDGE: "SOVRA Edge",
  SOVRA_EDGE: "SOVRA Edge",
};

const PORTAL_NAMES: Record<string, string> = {
  SSC: "BidNet Direct",
  MERX: "Merx",
};

/**
 * Human-readable product name for a source_application code.
 * Unknown or empty codes fall back to "your application" so raw codes never
 * appear in the UI.
 */
export function sourceApplicationDisplayName(code?: string | null): string {
  const normalized = code?.trim().toUpperCase();
  if (!normalized) {
    return FALLBACK;
  }

  const separator = normalized.indexOf(":");
  const base = separator === -1 ? normalized : normalized.slice(0, separator);
  const portal = separator === -1 ? "" : normalized.slice(separator + 1).trim();

  if (portal && PORTAL_NAMES[portal]) {
    return PORTAL_NAMES[portal];
  }
  if (BASE_NAMES[base]) {
    return BASE_NAMES[base];
  }
  if (BASE_NAMES[normalized]) {
    return BASE_NAMES[normalized];
  }
  return FALLBACK;
}
